import { Pipe, PipeTransform } from '@angular/core';

type AbstractType<T> = abstract new (...args: any[]) => T;

@Pipe({
	name: 'getSpecifiedOption'
})
export class GetSpecifiedOptionPipe implements PipeTransform {
	public transform<V, R>(options: V[] | undefined, type: AbstractType<R>): V | undefined {
		return options?.find(option => option instanceof type);
	}
}
